import {useTranslation} from 'react-i18next'

type Props = {
 isOpen: boolean
 onClose: () => void
 comment: string
 setComment: (val: string) => void
 onSubmit: () => void
}

const ResolutionCommentModal = ({
 isOpen,
 onClose,
 comment,
 setComment,
 onSubmit,
}: Props) => {
 const {t} = useTranslation()
 if (!isOpen) return null

 const isValid = comment.trim().length > 0

 return (
  <div className='fixed inset-0 z-50 flex items-center justify-center'>
   <div
    className='absolute inset-0 bg-black/60'
    onClick={onClose}
   />

   <div className='relative w-[756px] rounded-[24px] bg-white p-9 shadow-2xl'>
    <button
     onClick={onClose}
     className='absolute top-4 right-4 flex h-11 w-11 items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200'
    >
     <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
     >
      <path
       d='M2 2L16 16M16 2L2 16'
       stroke='#1F2937'
       strokeWidth='2.5'
       strokeLinecap='round'
      />
     </svg>
    </button>

    <h2 className='mb-6 text-[22px] font-bold text-gray-900'>
     {t('ticket.resolutionComment.title')}
    </h2>

    <div className='rounded-lg border border-gray-200 px-4 pt-2 pb-2 focus-within:border-[#4E83E4]'>
     <label className='block text-xs text-[#4E83E4]'>
      {t('ticket.resolutionComment.label')}
      <span className='text-red-500'>*</span>
     </label>
     <textarea
      value={comment}
      onChange={(e) => setComment(e.target.value)}
      placeholder={t(
       'ticket.resolutionComment.placeholder'
      )}
      className='h-[60px] w-full resize-y bg-white text-base text-gray-800 outline-none placeholder:text-gray-400'
     />
    </div>

    <button
     onClick={() => {
      if (isValid) onSubmit()
     }}
     disabled={!isValid}
     className={`mt-6 w-full rounded-lg py-3 text-sm font-semibold transition ${
      isValid
       ? 'bg-[#5B80DC] text-white hover:bg-[#4E83E4]'
       : 'cursor-not-allowed bg-gray-100 text-gray-400'
     }`}
    >
     {t('ticket.resolutionComment.button')}
    </button>
   </div>
  </div>
 )
}

export default ResolutionCommentModal
